import styled, { Interpolation } from 'styled-components';

type props = {
  styles?: Interpolation<React.CSSProperties>
	fullScreenEnabled?:boolean;
	isParentSQ?: boolean;
}

export const PanelTitle = styled.div`
	width: calc(50% - 5px);
	display: flex;
	flex-direction: column;
	gap: 5px;

	 @media (max-width: 935px){
    width: auto;
    flex-direction: row;
    align-items: center;
  }

	@media (max-width: 540px){
    width: auto;
    flex-direction: row;
  }
 

	@media (max-width: 640px){
		width: calc(49% - 0.5rem);
	}

	@media (max-width: 480px){
		width: 100%;
	}
	
		h4 {
			color: var(--textColor);
			font-weight: 500;
			font-size: 14px;
			line-height:16px;
			margin: 0;
			white-space: nowrap;
			font-family: 'Inter';
				@media (max-width: 935px){
				 		&:after{
							content: ':';
						}
				}
		}

		h2 {
			color: var(--primary);
			font-size: 16px;
			line-height:18px;
			font-weight: 600;
			margin: 0;
		}
		.primary-color{
			color: var(--primary);
		}
		.bold{
			font-weight:700;
		}
		.font-1{
			font-size:1rem;
		}
`;

export const PanelElement = styled(PanelTitle)`
		width: 100%;

		.switchButton{
			font-size: 14px;
		}
		.showPanel{ margin-bottom: 2px; }

		.react-change-panel__control{	}
			.react-change-panel__menu{
			    margin-top: 4px;
					cursor: pointer;
					overflow: hidden;
					background-color: var(--selectDropdownBgColor);

					.react-change-panel__menu-list{
							padding-block: 0;
    					overflow-x: hidden;
							overflow-y: auto;
							scrollbar-width: thin;       
							scrollbar-color: #94a3b8 transparent;

							&::-webkit-scrollbar {
								width: 4px;
							}

							&::-webkit-scrollbar-track {
								background: transparent;
							}

							&::-webkit-scrollbar-thumb {
								background-color: #94a3b8;
								border-radius: 10px;
							}

							&::-webkit-scrollbar-thumb:hover {
								background-color: #64748b;
							}
						.react-change-panel__option{
						 	overflow: hidden;
							background-color: var(--selectDropdownBgColor);
							&.react-change-panel__option--is-focused{
									background-color: var(--selectDropdownHoverColor)
							}
							&.react-change-panel__option--is-selected{
								background-color: var(--selectDropdownActiveColor);
							}		
							> div {
								padding-block: 6px; 
							}
						}
					}
			}
`;

export const FlexDiv = styled.div<props>`
	display: flex;
	flex-direction: row;
	margin-top: .2em;
	margin-bottom: 1em;
	align-items:center;
	${({ styles }) => styles}

	// @media (max-width: 500px){
	// 	margin-bottom: 1rem;
	// }
	
	label{
		color: var(--textHeadingColor);
		margin-right:8px;
		margin-top:0px;
		font-size: 1.05rem;
	}
`;
export const FlexDivRow = styled.div<props>`
	display: flex;
	flex-direction: row;
	justify-content:space-between;
	margin-top: .85rem;
	margin-bottom: .35rem;
	align-items:center;
	width:100%;
	gap:.3rem;
	${({ styles }) => styles}

	// @media (max-width: 500px){
	// 	margin-bottom: 1rem;
	// }
	
	label{
		color: var(--textColor);
		margin-right:0px;
		margin-bottom:0px;
		font-size: 1.05rem;
		font-weight:500;
		font-family: 'Inter';
		opacity:.95
	}
`;

export const RightArrow = styled.div`
		position: absolute;
		right:20px;
		top:13px;
`;

export const DivDesktop = styled.div`
	position: relative;
`;